import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-formula-meta',
    templateUrl: './formula-meta.component.html',
    styleUrls: ['./formula-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('formula-meta')
export class FormulaMetaComponent {
    model = input<any>();

    public defaultScript: string = 'source => {\n    let result = null; // result is a string\n    // ... your code to generate the formula value\n    return result;\n}';
    metaScript: any = { id: 'script', name: 'JavaScript', rows: 24, textStyle: '{"font-family":"monospace"}' };
}
